<div class="pm-icon-container" [ngClass]="type">
  <span
    class="material-symbols-outlined pm-icon"
    [ngClass]="{ fill: fill, DISABLED: disabled }"
    [ngStyle]="{ color: color ? color : '', fontWeight: weight ? weight : '' }"
    >{{ icon }}</span
  >
</div>
